<script setup lang="ts">
import { toRefs } from 'vue';

import CompanySwitcher from '@/components/CompanySwitcher.vue';
import NavbarUserDropdown from '@/components/NavbarUserDropdown.vue';
import { useUserStore } from '@/stores/user';

import IconIntercom from '../icons/IconIntercom.vue';

const userStore = useUserStore();
const { currentUser } = toRefs(userStore);
</script>

<template>
  <header>
    <div
      class="app-name"
      data-testid="app-name"
    >
      Messages
    </div>

    <div class="right">
      <CompanySwitcher v-if="currentUser?.superAdmin" />

      <div id="notifications" />

      <a
        href="https://influence-help.brandwatch.com/en/"
        class="intercom-link"
        target="_blank"
      >
        <IconIntercom />
      </a>
      <NavbarUserDropdown :initials="currentUser?.initials" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
header {
  background: var(--white);
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  border-bottom: 1px solid var(--border-default);
}

.app-name {
  font-size: 24px;
  font-weight: 700;
}

.right {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.intercom-link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 60px;
  width: 60px;
  border-radius: 2px;
  transition: 0.2s background-color;

  &:hover {
    background-color: var(--gray);
  }
}
</style>
